"use strict";

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

exports.implementation = /*#__PURE__*/function () {
  function NavigatorIDImpl() {
    _classCallCheck(this, NavigatorIDImpl);
  }

  _createClass(NavigatorIDImpl, [{
    key: "appCodeName",
    get: function get() {
      return "Mozilla";
    }
  }, {
    key: "appName",
    get: function get() {
      return "Netscape";
    }
  }, {
    key: "appVersion",
    get: function get() {
      return "4.0";
    }
  }, {
    key: "platform",
    get: function get() {
      return "";
    }
  }, {
    key: "product",
    get: function get() {
      return "Gecko";
    }
  }, {
    key: "productSub",
    get: function get() {
      return "20030107";
    } // see Navigator constructor for userAgent

  }, {
    key: "vendor",
    get: function get() {
      return "Apple Computer, Inc.";
    }
  }, {
    key: "vendorSub",
    get: function get() {
      return "";
    }
  }]);

  return NavigatorIDImpl;
}();